import PermissionMatrix, { permissionObject } from '../../components/PermissionMatrix';
import { SIDEBAR_CONFIG } from './userRight/UserRight';

import axios from 'axios'
import { useState, useEffect, useCallback } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";


const Role = () => {

    const companyID = localStorage.getItem('companyID');
    const [permissions, setPermissions] = useState({});
    const [permissionBranches, setPermissionBranches] = useState([]);

    const [showForm, setShowForm] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const handleAddClick = () => {
        setForm({ department: '', role: '' });
        setPermissions({});
        setIsEditMode(false);
        setShowForm(true);
    };

    const [form, setForm] = useState({
        department: '',
        role: ''
    })
    const [department, setDepartment] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');

    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!companyID || !Number.isSafeInteger(Number(companyID)) || Number(companyID) <= 0) {
            showToast('Select a company in the current login context before saving a role.', 'warning');
            return;
        }
        const sendData = { department: form.department, role: form.role, company_id: Number(companyID), permissions };
        try {
            if (isEditMode) {
                await axios.put('https://api.skyguard.group/api/update-role/' + form.id, sendData);
            } else {
                await axios.post('https://api.skyguard.group/api/add-role', sendData);
            }
            fecthDetail();
            setShowForm(false);
            setIsEditMode(false);
            setForm({ department: '', role: '' });
            setPermissions({});
            showToast(isEditMode ? 'Role updated successfully!' : 'Role Added successfully!', 'success');
        } catch (error) {
            showToast(error.response?.data?.error || 'Failed to save Role', 'danger');
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://api.skyguard.group/api/delete-role/${id}`);
            //   setRoles(roles.filter((role) => role.id !== id)); // remove from frontend list
            showToast("Role deleted successfully");
            fecthDetail();

        } catch (err) {
            console.error("Error deleting role:", err);
            showToast(err.response?.data?.error || "Failed to delete role", "danger");
        }
    };

    
    const openModal = (id) => {
        setSelectedId(id); 
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedId(null);
    }


    const confirmDelete = () => {
        if (selectedId) {

            handleDelete(selectedId);
        }
        closeModal();
    };


    const fecthDetail = useCallback(async () => {

        try {
            const resParty = await axios.get('https://api.skyguard.group/api/fetch-role', { params: companyID ? { company_id: companyID } : {} });
            setDepartment(resParty.data.result);
        } catch (error) {
            console.log(error)
        }
    }, [companyID]);

    useEffect(() => {
        fecthDetail();
        axios.get('https://api.skyguard.group/api/fetch-branch').then(response =>
            setPermissionBranches((response.data.result || []).filter(branch => Number(branch.company_id) === Number(companyID))))
            .catch(error => showToast('Failed to load permission branches', 'danger'));
    }, [companyID, fecthDetail]);


    const handleEdit = (form) => {
        try { setPermissions(permissionObject(form.permissions)); }
        catch (error) { showToast("Invalid role permissions; editing is blocked to preserve data.", "danger"); return; }

        setForm({
            id: form.id || '',
            department: form.department || '',
            role: form.role || ''
        });
        setEditingCompanyId(form.id);
        setIsEditMode(true);
        setShowForm(true);
    };

    const filterRole = department.filter((tt) => {
        const term = searchTerm.toLowerCase();

        return (
            (tt.department && tt.department.toLowerCase().includes(term)) ||
            (tt.role && tt.role.toString().toLowerCase().includes(term))

        );
    });


    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />
                    <h3 className='my-3 fw-bold fs-5 golos'>Master of role</h3>
                    <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

                        {/* LEFT: Search Bar */}
                        <div className="mb-2 w-50 w-md-50 pe-md-2">
                            <input
                                className="form-control w-100"
                                list="datalistOptions"
                                placeholder="Search by Role,Department...."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>

                        {/* RIGHT: Add Button */}
                        <div className="mb-2">
                            <button className="btn btn-success" onClick={handleAddClick}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>

                    </div>


                    {showForm && (


                        <div className='card p-3 mb-3  w-75 mx-auto'>
                            <form onSubmit={handleSubmit} >

                       {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {form.department}
    </span>
  </div>
)}

                                <hr />

                                <div className='row g-3'>

                                  

                                    <div className="col-md-6">
                                        <label htmlFor='name' className="form-label fw-medium" >Department</label>
                                        <input type="text" className="form-control" name="department" placeholder="Enter here..." value={form.department} onChange={handleInputChange} required />
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor='middle' className="form-label fw-medium" > Role</label>
                                        <input type="text" className="form-control" name="role" placeholder="Enter here..."
                                            value={form.role}
                                            onChange={handleInputChange}

                                        />
                                    </div>

                                    <PermissionMatrix key={isEditMode ? form.id : 'new'} config={SIDEBAR_CONFIG}
                                        permissions={permissions} setPermissions={setPermissions} branches={permissionBranches}
                                        showAllModules selectAllAllowed />

                                    <div className='gap-2 d-flex justify-content-center mt-4'>

                                        <button type="submit" className='btn btn-success w-10'>
                                            {isEditMode ? "Update" : "Save"}
                                        </button>
                                        <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                            setShowForm(false);
                                            setIsEditMode(false);
                                            setPermissions({});
                                            setForm({
                                                department: '',
                                                role: "",
                                            })
                                        }}>
                                            Cancel
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    )}



                    {showModal && (
                        <div
                            className="modal fade show"
                            style={{
                                display: "block",
                                backgroundColor: "rgba(0,0,0,0.5)",
                            }}
                            tabIndex="-1"
                        >
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Confirm Delete</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={closeModal}
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <p>
                                            Are you sure you want to delete role .
                                            <strong>{selectedId}</strong>?
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-secondary" onClick={closeModal}>
                                            Cancel
                                        </button>
                                        <button className="btn btn-danger" onClick={confirmDelete}>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>

                            <thead className='table-info'>
                                <tr>
                                  
                                    <th scope='col'>SN</th>
                                       <th scope='col'>Action</th>
                                    <th scope='col'>Department</th>
                                    <th scope='col'>Role</th>

                                   
                                </tr>
                            </thead>
                            <tbody>
                                {filterRole.map((acc, idx) => (
                                    <tr key={idx} >
                                          <td>{idx + 1}</td>

                                       <td>  <button
                                            className="btn btn-success"

                                            onClick={() => handleEdit(acc)}
                                        >
                                            <CiEdit size={20} />
                                        </button>
                                        <button type="button" className="btn btn-danger ms-2" aria-label="Delete role" onClick={() => openModal(acc.id)}><AiOutlineDelete size={20} /></button>
                                        </td>
                                      
                                        <td>
                                            {acc.department}
                                        </td>
                                        <td> {acc.role}  </td>
                                      
                                    </tr>


                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

        </>
    )
}
export default Role
